import React, { Component } from 'react';
import styled from 'styled-components';
import Breadcrumb from '../navs/Breadcrumb';
import UserNav from '../navs/UserNav';
import { getTheme, screen } from '../../global/utils';

const Header = styled.div`
  background: ${getTheme('bg', 'light3')};
  height: ${getTheme('height', 'header')};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  @media (max-width: ${screen('xlMax')}) {
    width: 100vw;
  }
`;

class MainHeader extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      project: '',
    };
  }
  componentWillMount() {
    //Change 'auniaweb_auth_rol' to the proper item
    let projectName = localStorage.getItem('auniaweb_auth_project');

    if (!projectName || projectName.length === 0) {
      projectName = 'Project';
    }
    this.setState({
      project: projectName,
    });
  }

  render() {
    return (
      <Header>
        {this.props.children}
        <Breadcrumb project={this.state.project} />
        <UserNav />
      </Header>
    );
  }
}

export default MainHeader;



// WEBPACK FOOTER //
// ./src/components/shared/MainHeader.js